import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';

export default function LazyLoadImageProp({ imageSrc, onError, className }) {
  return (
    <div>
      <LazyLoadImage
        alt="shoorah_image"
        wrapperClassName="w-full h-full"
        onError={onError}
        className={`${className ? className : 'h-10 w-10 border-2 rounded-full'} object-cover`}
        src={imageSrc}
        effect="blur"
      />
    </div>
  );
}

LazyLoadImageProp.propTypes = {
  imageSrc: PropTypes.any,
  className: PropTypes.any
};
